<template>
  <div class="block-company-container" :class="[device_platform]">
    <h2 class="title">Акции и предложения брендов</h2>
    <!-- <div class="content-container" :class="{'content-container--open': opened}"> -->
      <div class="slider-company">
        <div class="slider-company__wrapper">
          <div 
            class="slider-company__item"
            v-for="item in company" 
            :key="item.name"
          >
            <div class="company-item">
              <div class="brand-item-wrapper">
                <div class="brand-item">
                  <p class="brand-text" :class="`brand-icon_${item.alias}`"></p>
                </div>
              </div>
              <a href="#" :title="item.name" @click.prevent="$root.$emit('callback-popup-open', 'Заказать обратный звонок')">
                <img :src="require(`../img/company/new/${item.img}`)" alt="">
              </a>
            </div>
          </div>
        </div>
        <!-- Add Arrows -->
        <div class="slider-company__button slider-company__button-next"></div>
        <div class="slider-company__button slider-company__button-prev"></div>
      </div>
    <!-- </div> -->
    <!-- <button class="show-more button" @click="opened=true" v-show="!opened">Показать еще</button> -->
  </div>
</template>

<script>
import Swiper from 'swiper';
import Mixin from "../common/mixin";

export default {
  name: "block-company",
  mixins: [Mixin],
  data() {
    return {
      opened: true,
      company: [
        { img: "lexus.jpg", alias: "lexus", title: "Lexus" },
        { img: "toyota.jpg", alias: "toyota", title: "Toyota" },
        { img: "baic.jpg", alias: "baic", title: "baic" },
        { img: "faw.jpg", alias: "faw", title: "faw" },
        { img: "jetta.jpg", alias: "jetta", title: "jetta" },
        { img: "kaiyi.jpg", alias: "kaiyi", title: "kaiyi" },
        { img: "moskvich.jpg", alias: "moskvich", title: "moskvich" },
        { img: "hyundai.jpg", alias: "hyundai", title: "Hyundai" },
        { img: "mg.jpg", alias: "mg", title: "MG" },
        { img: "changan.jpg", alias: "changan", title: "Changan" },
        { img: "chery.jpg", alias: "chery", title: "Chery" },
        { img: "exeed.jpg", alias: "exeed", title: "Exeed" },
        { img: "skywell.jpg", alias: "skywell", title: "Skywell" },
        { img: "skoda.jpg", alias: "skoda", title: "Skoda" },
        { img: "volkswagen.jpg", alias: "volkswagen", title: "Volkswagen" },
        { img: "citroen.jpg", alias: "citroen", title: "Citroen" },
        { img: "jaecoo.jpg", alias: "jaecoo", title: "Jaecoo" },
        { img: "omoda-new.jpg", alias: "omoda", title: "Omoda" },
        { img: "peugeot.jpg", alias: "peugeot", title: "Peugeot" },
        { img: "livan.jpg", alias: "livan", title: "Livan" },
        { img: "lada.jpg", alias: "lada", title: "LADA" },
        { img: "haval.jpg", alias: "haval", title: "Haval" },
        { img: "geely.jpg", alias: "geely", title: "Geely" },
        { img: "land-rover.jpg", alias: "land_rover", title: "Land Rover" },
      ],
    };
  },
  mounted() {
    new Swiper('.slider-company', {
      loop: true,
      autoplay: {
        delay: 5000
      },
      slidesPerView: 7,
      spaceBetween: 40,
      slideClass: 'slider-company__item',
      wrapperClass: 'slider-company__wrapper',
      navigation: {
        nextEl: '.slider-company__button-next',
        prevEl: '.slider-company__button-prev',
      },
      breakpoints: {
        480: {
          slidesPerView: 1,
          spaceBetween: 10,
        },
        800: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        1280: {
          slidesPerView: 3,
          spaceBetween: 40,
        },
        1600: {
          slidesPerView: 4,
          spaceBetween: 40,
        },
        1920: {
          slidesPerView: 5,
          spaceBetween: 20,
        }
      },
    });
  },
};
</script>

<style scoped lang="scss">

.mobile {
  .content-container--open {
    max-height: 3000px;
  }
}

.block-company-container {
  width: 100%;
  height: auto;
  padding: 50px;
  margin: 0 auto;
  background: linear-gradient(to bottom, #e6e7e9, #fff);
}

.title {
  margin-bottom: 40px;
  font-size: 36px;
  font-weight: bold;
  text-align: center;
  line-height: 100%;
}

// .content-container {
//   display: grid;
//   grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
//   gap: 40px;
//   justify-items: center;
//   transition: max-height 0.75s;
// }

// .content-container--open {
//   max-height: 3000px;
//   transition: max-height 0.75s;
// }

.slider-company {
    position: relative;
    height: 500px;
    overflow: hidden;

    &__wrapper {
      display: flex;
      justify-items: center;
    }

    &__item {
      position: relative;
      flex-shrink: 0;
      display: flex;
      align-items: end;
    }

    &__button {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      width: 73px;
      height: 111px;
      background-size: cover;

      &-prev {
        left: 0;
        background-image: url("../img/icons/arrow-left.png");
      }
      
      &-next {
        right: 0;
        background-image: url("../img/icons/arrow-right.png");
      }

      @media (max-width: 800px) {
        width: 50px;
        height: 88px;
      }
    }
}

.company-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  // width: 300px;
  text-align: center;
  box-sizing: border-box;
}

.show-more {
  border: none;
  margin: 0 auto;
  cursor: pointer;

  &:hover {
    opacity: 0.85;
  }
}

.brand-item {
  width: max-content;
  margin-bottom: 10px;
  padding: 10px;
  border-radius: 10px;
  // background-color: #fff;
}

.brand-text {
  display: flex;
  align-items: center;
  margin: 0;
  color: #000;
  font-size: 24px;
  text-decoration: none;
}

.brand-icon {
  @each $icon in'chery','hyundai', 'citroen', 'geely',
    'peugeot', 'skywell', 'mg', 'lexus', 'jetta', 'kaiyi',
    'toyota'  {
    &_#{$icon}::before {
        content: '';
        display: block;
        width: 80px;
        height: 65px;
        margin-right: 10px;

        background-image: url("../img/icons/brands/#{$icon}.png");
        background-repeat: no-repeat;
        background-size: contain;
        background-position: center;
    }
  }
  @each $icon in 'geely', 'changan', 'haval', 'exeed',
    'skoda', 'volkswagen', 'jaecoo', 'omoda', 'livan',
    'lada', 'land_rover', 'baic', 'faw', 'moskvich'{
    &_#{$icon}::before {
        content: '';
        display: block;
        width: 120px;
        height: 65px;
        margin-right: 10px;

        background-image: url("../img/icons/brands/#{$icon}.png");
        background-repeat: no-repeat;
        background-size: 100%;
        background-position: center;
    }
  }
}

@media (max-width: 740px) {
  .block-company-container {
    background: #fff;
  }

  .brand-item-wrapper {
    width: 100%;
    padding: 10px;
    border-radius: 10px 10px 0 0;
    background: linear-gradient(to bottom, #e6e7e9, #fff);
  }

  .brand-item {
    margin: 0 auto;
  }
}

@media (max-width: 400px) {
  .block-company-container {
    padding: 0 10px 50px;
  }
}
</style> 
